import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { facilityAdmin } from "../../api";
import BRAND from "../../brand";

// "Export" button with CSV / PDF / PowerPoint. The file is built on the server from the same
// data as the page, using the filters currently chosen (`params`).

const FORMATS = [
  ["csv", "CSV", "for Excel and other spreadsheets"],
  ["pdf", "PDF", "to read, print or send"],
  ["pptx", "PowerPoint", "slides with editable charts"],
];

function fileName(resp, fallback) {
  const m = /filename="?([^";]+)"?/i.exec(resp.headers?.["content-disposition"] || "");
  return m ? m[1] : fallback;
}

export default function ExportMenu({ report, params, style }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState("");
  const box = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  const run = async (fmt) => {
    setBusy(fmt);
    try {
      const clean = Object.fromEntries(Object.entries({ ...params, report, fmt }).filter(([, v]) => v !== undefined && v !== null && v !== ""));
      const resp = await facilityAdmin.exportReport(clean);
      const url = URL.createObjectURL(resp.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName(resp, `${report}.${fmt}`);
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
      setOpen(false);
    } catch (err) {
      toast.error(err.response?.status === 501 ? `${fmt.toUpperCase()} export is not available on this server.` : "Could not create the file.");
    } finally {
      setBusy("");
    }
  };

  return (
    <div ref={box} style={{ position: "relative", ...style }}>
      <button style={S.btn} onClick={() => setOpen((o) => !o)}>Export ▾</button>
      {open && (
        <div style={S.menu}>
          {FORMATS.map(([fmt, label, hint]) => (
            <button key={fmt} style={S.item} disabled={!!busy} onClick={() => run(fmt)}>
              <b>{busy === fmt ? "Creating…" : label}</b>
              <span style={S.hint}>{hint}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

const S = {
  btn: { background: BRAND.colorPrimary, color: "#fff", border: "none", borderRadius: 10, padding: "9px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" },
  menu: { position: "absolute", right: 0, top: "calc(100% + 6px)", zIndex: 30, minWidth: 230, background: "var(--surface-bg-solid)", border: "1px solid var(--surface-border)", borderRadius: 12, boxShadow: "0 10px 30px rgba(0,0,0,0.18)", padding: 6, display: "flex", flexDirection: "column" },
  item: { display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2, background: "transparent", border: "none", borderRadius: 8, padding: "9px 12px", fontSize: 13, color: "var(--text-primary)", cursor: "pointer", fontFamily: "inherit", textAlign: "left" },
  hint: { fontSize: 11, color: "var(--text-secondary)" },
};
